import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../api/Constants';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import ERROR_CODE from '../../utils/errorCodes';
import RequestHelper from '../../api/RequestHelper';
export var initProperty = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return RequestHelper.apiGet({
              endpoint: Endpoints.PROPERTIES,
              shouldSkipIsConnectedCheck: true,
              headers: {
                forceJsonObject: 'no'
              }
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initProperty() {
    return _ref.apply(this, arguments);
  };
}();
export var getTexts = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var assetBaseUrl, texts, url, getTextsResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            assetBaseUrl = _ref2.assetBaseUrl, texts = _ref2.texts;
            _context2.prev = 1;
            url = assetBaseUrl + '/' + texts;
            _context2.next = 5;
            return fetch(url);

          case 5:
            getTextsResponse = _context2.sent;
            _context2.next = 8;
            return getTextsResponse.json();

          case 8:
            return _context2.abrupt("return", _context2.sent);

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
              code: ERROR_CODE.GET_TEXTS_FAIL
            });

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));

  return function getTexts(_x) {
    return _ref3.apply(this, arguments);
  };
}();